import { FEATURES } from '@/access/features';

export default {
  type: 'everee',
  engagement: true,
  icon: 'everee',
  title: 'Everee Onboarding',
  help: 'Embed Everee onboarding experience',
  is_new: true,
  feature: FEATURES.EVEREE,
  schema: {
    contact_info_note: {
      type: 'Content',
      content:
        "The contact's <strong>first name</strong>, <strong>last name</strong>, " +
        '<strong>mobile phone</strong>, and <strong>email</strong> are automatically ' +
        'sent to Everee from the contact profile. Make sure these fields are populated ' +
        'before the contact reaches this Everee onboarding experience.',
    },

    start_date_field: {
      type: 'ContactFieldList',
      title: 'Start Date',
      help:
        'Required. Select the contact field that contains the contractor start date. ' +
        'If no value is set on the contact, the current date will be used.',
      only_types: ['date'],
      default: '',
      validators: ['required'],
    },

    contact_address_note: {
      type: 'Content',
      content:
        "The contact's <strong>home address</strong> is required for the onboarding experience. Please select the contact field that contains the home address.",
    },

    address_line1_field: {
      type: 'ContactFieldList',
      title: 'Address Line 1',
      help: 'Required. Street address (e.g. 123 Main St)',
      default: '',
      validators: ['required'],
    },

    address_line2_field: {
      type: 'ContactFieldList',
      title: 'Address Line 2',
      help: 'Apartment, suite, unit, etc. (optional)',
      default: '',
    },

    address_city_field: {
      type: 'ContactFieldList',
      title: 'Address City',
      help: "Required. City of the contact's home address.",
      default: '',
      validators: ['required'],
    },

    address_state_field: {
      type: 'ContactFieldList',
      title: 'Address State',
      help: "Required. State of the contact's home address.",
      default: '',
      validators: ['required'],
    },

    address_postal_code_field: {
      type: 'ContactFieldList',
      title: 'Postal/Zip Code',
      help: "Required. Postal/Zip code of the contact's home address.",
      default: '',
      validators: ['required'],
    },

    account_setup_enabled: {
      type: 'Checkbox',
      title: 'Account Setup Enabled',
      help: 'Whether the onboarding requires setting up an Everee login account. When disabled, no login account or password will be created.',
      default: true,
    },
    branding_enabled: {
      type: 'Checkbox',
      title: 'Branding Enabled',
      help: 'Whether a logo appears at the bottom of each component view.',
      default: true,
    },
    onboarding_back_button_enabled: {
      type: 'Checkbox',
      title: 'Back Button Enabled',
      help: 'Whether the back button is visible in the onboarding component.',
      default: true,
    },
    button_text: {
      type: 'Text',
      title: 'Custom Button Text',
      help: 'Customize the text of the button that opens Everee onboarding.',
      default: 'Start Onboarding',
    },
    success_text: {
      type: 'Text',
      title: 'Success Message',
      help: 'Message shown after onboarding is complete.',
      default: 'Onboarding complete! You are all set.',
    },
    open_popup: {
      type: 'Checkbox',
      title: 'Show immediately',
      default: true,
    },
    can_advance: {
      type: 'Checkbox',
      default: false,
      title: 'Can Skip. Do not require.',
      help: 'Allow advancing without completing onboarding.',
    },
  },
};
